<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none" stroke="currentColor">
        <path d="M3.4999 2.1001H10.4999C11.2731 2.1001 11.8999 2.7269 11.8999 3.5001V10.5001C11.8999 11.2733 11.2731 11.9001 10.4999 11.9001H3.4999C2.7267 11.9001 2.0999 11.2733 2.0999 10.5001V3.5001C2.0999 2.7269 2.7267 2.1001 3.4999 2.1001Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6.9999 10.1501H7.0069" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
